import { createAction, props } from '@ngrx/store';
import * as models from '../../domain/models';

export const load = createAction('[TaskMgmt.DelayCodesCollection] Load');
export const loadSuccess = createAction(
  '[TaskMgmt.DelayCodesCollection] Load Success',
  props<{ payload: Array<models.DelayCode> }>()
);
export const loadFail = createAction('[TaskMgmt.DelayCodesCollection] Load Fail');
